import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { staffClient } from 'clients/staff';
import PageContainer from 'ui/PageContainer';
import Loading from 'ui/Loading';

const SiteRouter = () => {
    const [loading, setLoading] = useState(true);
    const [redirectPath, setRedirectPath] = useState<string | null>(null);

    useEffect(() => {
        determineSiteToShow();
    }, []);

    const determineSiteToShow = async () => {
        try {
            // 1. localStorage에서 최근 방문 현장 확인
            const lastVisitedSiteId = localStorage.getItem('lastVisitedSiteId');

            // 2. 현장 목록 가져오기
            const response = await staffClient.get('/site', {
                params: { limit: 1000 }
            });
            const sites = response.data?.data || [];

            if (sites.length === 0) {
                // 현장이 없는 경우 - 현장 목록으로 리다이렉트
                setRedirectPath('/sites/list');
                return;
            }

            // 3. 최근 방문 현장이 있고 여전히 존재하는지 확인
            if (lastVisitedSiteId) {
                const siteExists = sites.some((site: any) =>
                    site.id?.toString() === lastVisitedSiteId
                );

                if (siteExists) {
                    setRedirectPath(`/sites/${lastVisitedSiteId}`);
                    return;
                }
            }

            // 4. 최근 방문 현장이 없거나 삭제된 경우 - 첫 번째 현장으로
            const firstSiteId = sites[0].id;
            setRedirectPath(`/sites/${firstSiteId}`);

        } catch (error) {
            console.error('Failed to determine site:', error);
            // 에러 발생 시 테스트용 더미 데이터로 처리
            const lastVisitedSiteId = localStorage.getItem('lastVisitedSiteId');

            // 더미 데이터
            const dummySites = [
                { id: 1, name: '산성구역 주택재개발정비사업' },
                { id: 2, name: '강북 도시정비사업' },
                { id: 3, name: '분당 신도시 재건축' },
            ];

            if (lastVisitedSiteId) {
                const siteExists = dummySites.some(site =>
                    site.id.toString() === lastVisitedSiteId
                );

                if (siteExists) {
                    setRedirectPath(`/sites/${lastVisitedSiteId}`);
                    return;
                }
            }

            // 첫 번째 더미 현장으로
            setRedirectPath('/sites/1');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <PageContainer>
                <Loading text="현장 정보를 불러오는 중..." />
            </PageContainer>
        );
    }

    if (redirectPath) {
        return <Navigate to={redirectPath} replace />;
    }

    // 예외 상황 - 현장 목록으로 이동
    return <Navigate to="/sites/list" replace />;
};

export default SiteRouter;
